export default __webpack_public_path__ + "static/media/gl.f260d3a1.svg";